import { Component } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { VERBIAGE } from 'src/app/config';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-push',
    templateUrl: './push-notification.component.html',
    styleUrls: ['./push-notification.component.scss']
})

export class PushNotificationComponent {
    constructor(private _shared: SharedService, private _notify: NotificationService) {
        // Setting up page title
        this._shared.pageTitle = 'Send Notifications';
    }

    onSubmit(form: NgForm) {
        if (form.valid) {
            // console.log(form.value);
            this._notify.sendPushNotification(form.value).subscribe(res => {
                if (res) {
                    this._notify.toastMessage({
                        color: 'accent', message: VERBIAGE.PUSH_NOTIFICATION_SUCCESS, duration: 3000
                    });
                    form.resetForm();
                }
            });
        }
    }
}